import {
  BooleanSetting,
  useUserSetting,
} from "shared-ts-utils-user-settings";

export const useConsentToCollectUsageData = () => {
  return useUserSetting<boolean>("consentToCollectUsageData", BooleanSetting);
};
